export enum SLOPE_VALUES {
  FLAT = 0,
  SHALLOW = 9.5,
  AVERAGE = 18.5,
  STEEP = 40,
}
